export default {
	footer: {
		'total-received': 'مجموع المقبوض',
		'paid-total': 'مجموع المدفوع',
		'the-difference': 'الفرق'
	},
	previous: 'السابق',
	next: 'التالي'
}